// What the dashboard's hero shows (Figma 15376-148247, 16102-26437): the
// first-pipeline onboarding only when there is nothing at all, no pipelines
// and no services, since with services in place the next step is a pipeline
// and the cards say so themselves — Health and Recent pipelines empty, the
// Services card listing what exists. A list still loading keeps the cards
// too: their own skeletons carry the page, and the onboarding must never
// flash in front of a dashboard that has something to show.

export type DashboardMode = "onboarding" | "cards";

export function dashboardMode(
  jobs: readonly unknown[] | undefined,
  services: readonly unknown[] | undefined,
): DashboardMode {
  const nothing = jobs?.length === 0 && services?.length === 0;
  return nothing ? "onboarding" : "cards";
}
